import { useFormikContext } from "formik";
import { useEffect, useMemo } from "react";

import useMultisportPageId from "web/hooks/useMulstisportPageId/useMultisportPageId";

import isMultisportPhrase from "./isMultisportPhrase";

// searchPhrase is updated on every keystroke, searchValue is updated after timeout
const useMultisportSearch = ({
  searchValue,
  searchPhrase,
}: {
  searchValue: string;
  searchPhrase: string;
}): void => {
  const multisportPageId = useMultisportPageId();
  const { setFieldValue } = useFormikContext<{
    [key: string]: string | boolean;
  }>();
  const isMultisportEnabled = typeof multisportPageId === "number";

  const hasMultisport = useMemo(() => {
    return isMultisportEnabled && isMultisportPhrase(searchValue);
  }, [searchValue, isMultisportEnabled]);

  const shouldRedirectToMultisport = useMemo(() => {
    return isMultisportEnabled && isMultisportPhrase(searchPhrase);
  }, [searchPhrase, isMultisportEnabled]);

  useEffect(() => {
    setFieldValue("hasMultisport", hasMultisport);
  }, [hasMultisport, setFieldValue]);

  useEffect(() => {
    setFieldValue("shouldRedirectToMultisport", shouldRedirectToMultisport);
  }, [shouldRedirectToMultisport, setFieldValue]);
};

export default useMultisportSearch;
